export function fmtMoney(value, currency = 'MXN') {
  const num = Number(value) || 0;
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: currency === 'USD' ? 'USD' : 'MXN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}

export function fmtNumber(value, decimals = 2) {
  return new Intl.NumberFormat('es-MX', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(value) || 0);
}

export function fmtDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return '—';
  }
}

export const STATUS_LABELS = {
  draft: 'Borrador',
  review: 'En revisión',
  finalized: 'Finalizada',
};

export const TIPO_LABELS = {
  construccion_prefab: 'Prefab',
  contenedor: 'Contenedor',
  fotovoltaico: 'Fotovoltaico',
};

export const ROLE_LABELS = {
  administrador: 'Administrador',
  editor: 'Editor',
  capturista: 'Capturista',
};

export function errMsg(error, fallback = 'Ocurrió un error') {
  return error?.response?.data?.detail || error?.message || fallback;
}
